import React, { useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import {
  Header1SemiBold,
  Header3SemiBold,
  SelectField as BaseSelectField,
  header1,
  FlexMiddle,
  InputField as BaseInputField
} from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { required } from '@ubeya/shared/utils/form';
import useGenericSettings from '@ubeya/shared/hooks/generic/useGenericSettings';

const Title = styled(Header1SemiBold)`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.black};
`;

const SubTitle = styled(Header3SemiBold)`
  margin-bottom: 50px;
  color: ${({ theme }) => theme.colors.black};
`;

const slideIn = keyframes`
	0% { transform: translateX(350px); }
	100% { transform:translateX(0); }
`;

const Row = styled(FlexMiddle)`
  ${header1};
  margin: 15px 0;
  flex-wrap: wrap;
  animation: ${slideIn} 200ms;
  color: ${({ theme }) => theme.colors.black};
`;

const SelectField = styled(BaseSelectField).attrs(() => ({ searchable: true }))`
  .select {
    margin-left: 10px;
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
    box-shadow: none;

    .select-label,
    .select-input {
      ${header1}
      padding: 0 10px;
      height: 40px;
      line-height: 40px;
      max-width: 300px;
    }

    .select-container {
      cursor: pointer;
    }

    .select-container[data-is-empty='false'] {
      padding-right: 0;
    }

    .select-container[data-is-empty='false'] {
      ~ .select-arrow {
        display: none;
      }
    }
  }
`;

const InputField = styled(BaseInputField)`
  input {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey2};
    box-shadow: none;
    margin-left: 10px;
    ${header1}
  }
`;

const InitialCompanyDetails = () => {
  const { t } = useContext(ConfigContext);

  const { countriesOptions } = useGenericSettings();

  return (
    <>
      <Title>{t('yourCompanyTitle')}</Title>
      <SubTitle>{t('yourCompanySubTitle', { step: 4 })}</SubTitle>

      <Row>
        <>
          My company name is <InputField name="name" validate={required} required $width={300} />
        </>
      </Row>
      <Row>
        <>
          and located in <SelectField name="countryId" options={countriesOptions} isMulti={false} />
        </>
      </Row>
    </>
  );
};

export default InitialCompanyDetails;
